var clamp = function clamp(a, min, max) {
  if (a < min) {
    return min;
  } else if (a > max) {
    return max;
  }

  return a;
};

module.exports = clamp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/math/clamp.js
// module id = 41
// module chunks = 0 1 2